import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { DonutChart } from '../../../shared';
import { DONUT_CHART_OPTIONS } from './constants';
import { colors } from '../../../../constants';

function EngagementSpecialty() {
    const { isLoading, specialtyEngagementData } = useSelector((state) => state.digitalEngagement);
    const { company } = useSelector((state) => state.company);
    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Physician Engagement by Specialty
                </Typography>
            </Box>
            <Box className="wh-70 align_center" id="engagement-specialty">
                {
                    isLoading ? <Skeleton height={400} variant="rectangular" width='100%' /> :
                        <DonutChart
                            chartName = "Physician Engagement by Specialty"
                            chartOptions={
                                {
                                    ...DONUT_CHART_OPTIONS, 
                                    labels: specialtyEngagementData.labels, 
                                    colors: colors
                                }
                            }
                            chartSeries={specialtyEngagementData.series}
                            companyId = {company.id}
                        />
                }
            </Box>
        </Box>
    );
}

export default EngagementSpecialty;
